import React from 'react';
import { useTranslation } from 'react-i18next';

import TooltipPlugin from 'component/Layout/Tooltip';
import { TooltipPosition } from 'component/Layout/Tooltip/types';

import { ReactComponent as IconCheckmarkCircleOutline } from 'media/svg/checkmarkCircleOutline.svg';
import { ReactComponent as IconInfoCircle } from 'media/svg/infoCircle.svg';

import { RatingSummaryType } from '../__helper';

import styles from './Tooltip.module.scss';

interface TooltipProps {
    type: RatingSummaryType;
    customClassList?: {
        Icon?: string;
    };
}
const Tooltip = ({ type, customClassList }: TooltipProps) => {
    const { t } = useTranslation();
    return (
        <TooltipPlugin
            content={
                <div>
                    <h3>
                        <IconCheckmarkCircleOutline />
                        {type === RatingSummaryType.Guest
                            ? t('TRANS-100-percent-real-ratings')
                            : t('TRANS-reviewed-ratings')}
                    </h3>
                    <p className={styles.SubHeadline}>
                        {t('TRANS-where-do-recommendations-come-from')}
                    </p>
                    <p>
                        {type === RatingSummaryType.Guest
                            ? t('TRANS-all-ratings-originate-from-real-guests')
                            : t('TRANS-trustyou-explained')}
                    </p>
                    {type === RatingSummaryType.Guest && (
                        <>
                            <p className={styles.SubHeadline}>
                                {t('TRANS-how-can-real-ratings-be-guaranteed')}
                            </p>
                            <p>{t('TRANS-guests-rate-after-return')}</p>
                        </>
                    )}

                    <p>
                        <a
                            href={`https://${t(
                                'TRANS-base-url-holding'
                            )}/unternehmen/ueber-uns/?product=25`}
                        >
                            {t('TRANS-know-more')}
                        </a>
                    </p>
                </div>
            }
            align={{ offset: [2, 5] }}
            placement={TooltipPosition.Bottom}
            overlayClassName={styles.Tooltip}
        >
            <div className={customClassList?.Icon}>
                <IconInfoCircle />
            </div>
        </TooltipPlugin>
    );
};

export default Tooltip;
